import VisuallyHidden from './VisuallyHidden';

export default function AccessibilityPause() {
  return <VisuallyHidden>,</VisuallyHidden>;
}
